import { ApsCandidate, DisclosureDoctor, DoctorRow, DxClaim } from './types';

export const dxClaimToApsCandidate = (
  claim: DxClaim,
  index: number,
): ApsCandidate => ({
  key: `dx-${claim.npi || claim.name}-${claim.id}-${index}`,
  source: 'Dx',
  information: '',
  specialization: claim.specialization,
  code: claim.code,
  description: claim.description,
  name: claim.name,
  npi: claim.npi,
  phoneNumber: claim.phoneNumber,
  address: claim.address,
  city: claim.city,
  state: claim.state,
  zipcode: claim.zipcode,
  facilityName: '',
  visitDate: claim.visitDate,
});

export const disclosureToApsCandidate = (
  row: DisclosureDoctor,
  index: number,
): ApsCandidate => ({
  key: `disclosure-${row.name || index}-${index}`,
  source: 'Disclosure',
  information: row.information,
  specialization: '',
  code: '',
  description: '',
  name: row.name,
  npi: '',
  phoneNumber: '',
  address: row.address,
  city: row.city,
  state: row.state,
  zipcode: row.zipcode,
  facilityName: '',
  visitDate: row.visitDate,
});

export const rxRowToApsCandidate = (
  row: DoctorRow,
  index: number,
): ApsCandidate => ({
  key: `rx-${row.npi || row.name}-${index}`,
  source: 'Rx',
  information: '',
  specialization: row.specialization,
  code: '',
  description: '',
  name: row.name,
  npi: row.npi,
  phoneNumber: row.phoneNumber,
  address: row.address,
  city: row.city,
  state: row.state,
  zipcode: row.zipcode,
  facilityName: '',
  visitDate: row.visitDate,
});

export const buildDisclosureAndDxCandidates = (
  disclosure: DisclosureDoctor[],
  dxClaims: DxClaim[],
): ApsCandidate[] => [
  ...disclosure.map(disclosureToApsCandidate),
  ...dxClaims.map(dxClaimToApsCandidate),
];
